export class NativeStreamStructOutputType {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamStructOutputKind",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<NativeStreamOutputField>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamStructOutputType.attributeTypeMap;
    }
    constructor() {
    }
}
